export default function EmploymentCreation() {
  const jobCategories = [
    {
      icon: 'ri-drop-line',
      title: '養殖管理スタッフ',
      description: '日々の養殖管理、給餌、水質チェックなどの業務',
      positions: '20名',
      requirements: ['未経験歓迎', '研修制度あり', '正社員雇用']
    },
    {
      icon: 'ri-settings-3-line',
      title: '設備管理スタッフ',
      description: '循環システムの保守・メンテナンス業務',
      positions: '10名',
      requirements: ['技術研修あり', '資格取得支援', '正社員雇用']
    },
    {
      icon: 'ri-flask-line',
      title: '品質管理スタッフ',
      description: '水質分析、製品品質管理などの業務',
      positions: '5名',
      requirements: ['理系歓迎', '専門研修あり', '正社員雇用']
    },
    {
      icon: 'ri-truck-line',
      title: '物流・営業スタッフ',
      description: '製品の出荷管理、販路開拓などの業務',
      positions: '8名',
      requirements: ['経験者優遇', '未経験可', '正社員雇用']
    }
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-[#F5F9F6] to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-white border border-[#C8E6C9] mb-6">
            <i className="ri-team-line text-[#2D7A3E] text-lg mr-2"></i>
            <span className="text-[#2D7A3E] text-sm font-semibold whitespace-nowrap">地域雇用の創出</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-6">
            100名以上の<br />
            新しい雇用を創出
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            養殖事業の立ち上げにより、地域に多様な雇用機会を提供します。<br />
            未経験者でも安心して働ける研修制度と、長期的なキャリア形成を支援します。
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {jobCategories.map((job, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-[#E8F5E9] text-center"
            >
              <div className="flex flex-col items-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-[#2D7A3E] to-[#4CAF50] rounded-xl flex items-center justify-center mb-3">
                  <i className={`${job.icon} text-white text-3xl`}></i>
                </div>
                <div className="bg-[#E8F5E9] px-4 py-2 rounded-lg">
                  <p className="text-sm font-semibold text-[#2D7A3E]">{job.positions}</p>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-[#1A2332] mb-3">{job.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{job.description}</p>
              <div className="space-y-2 inline-flex flex-col items-start">
                {job.requirements.map((req, idx) => (
                  <div key={idx} className="flex items-center">
                    <i className="ri-check-line text-[#2D7A3E] text-lg mr-2"></i>
                    <span className="text-sm text-gray-700">{req}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="bg-white p-10 rounded-2xl shadow-xl border border-[#E8F5E9]">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <div className="rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/21d6d2d6e6f8c0503816c8806bdd40d5.jpg"
                  alt="養殖施設で働くスタッフ"
                  className="w-full h-[450px] object-cover"
                />
              </div>
            </div>

            <div>
              <h3 className="text-3xl font-bold text-[#1A2332] mb-6">
                充実した研修制度と<br />
                キャリアサポート
              </h3>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#2D7A3E] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-book-open-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#1A2332] mb-2">充実した研修プログラム</h4>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      未経験者でも安心して働けるよう、基礎から専門知識まで段階的に学べる研修プログラムを用意。筑波大学の専門家による技術指導も受けられます。
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#2D7A3E] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-medal-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#1A2332] mb-2">資格取得支援</h4>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      養殖管理士、水質管理技術者などの専門資格取得を会社が全面的にサポート。キャリアアップを応援します。
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#2D7A3E] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-line-chart-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#1A2332] mb-2">長期的なキャリア形成</h4>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      現場スタッフから管理職、さらには新規拠点の責任者まで、明確なキャリアパスを用意。長期的に成長できる環境です。
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-8 p-6 bg-gradient-to-br from-[#F5F9F6] to-white rounded-xl border border-[#E8F5E9]">
                <h4 className="font-semibold text-[#1A2332] mb-3 flex items-center">
                  <i className="ri-hand-heart-line text-[#2D7A3E] text-xl mr-2"></i>
                  地域の方を優先採用
                </h4>
                <p className="text-sm text-gray-600 leading-relaxed">
                  地域住民の雇用を最優先に考え、地元の方々に安定した仕事を提供します。地域と共に成長する企業を目指します。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}